// Modules
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import { FormattedMessage } from "react-intl";
// Material-UI
import { Button, ButtonGroup, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material";
// Assets
import {
    IconChevronLeft,
    IconChevronRight,
    IconLayoutGrid,
    IconTemplate,
    IconLayoutList,
    IconListNumbers
} from "@tabler/icons-react";

// constant
const viewOptions = [
    {
        label: "month",
        value: "dayGridMonth",
        icon: IconLayoutGrid
    },
    {
        label: "week",
        value: "timeGridWeek",
        icon: IconTemplate
    },
    {
        label: "day",
        value: "timeGridDay",
        icon: IconLayoutList
    },
    {
        label: "agenda",
        value: "listWeek",
        icon: IconListNumbers
    }
];

const Toolbar = ({ locale, calendarActions, handleDatesSet = null, ...others }) => {
    const [view, setView] = useState("dayGridMonth");
    const [date, setDate] = useState(new Date());

    useEffect(() => {
        if (handleDatesSet) {
            handleDatesSet(date);
        }
    }, [date, handleDatesSet]);

    const handleChangeView = newView => {
        calendarActions("changeView", newView);
        setView(newView);
    };

    const handleClickToday = () => {
        calendarActions("today");
        setDate(calendarActions());
    };

    const handleClickPrev = () => {
        calendarActions("prev");
        setDate(calendarActions());
    };

    const handleClickNext = () => {
        calendarActions("next");
        setDate(calendarActions());
    };

    return (
        <Grid alignItems="center" container justifyContent="space-between" spacing={3} {...others} sx={{ pb: 3 }}>
            <Grid item>
                <Button variant="outlined" onClick={handleClickToday}>
                    <FormattedMessage id="today" />
                </Button>
            </Grid>
            <Grid item>
                <Stack direction="row" alignItems="center" spacing={3}>
                    <IconButton onClick={handleClickPrev} size="large">
                        <IconChevronLeft />
                    </IconButton>
                    <Typography variant="h3" color="textPrimary">
                        {format(date, "MMMM yyyy", {
                            locale
                        })}
                    </Typography>
                    <IconButton onClick={handleClickNext} size="large">
                        <IconChevronRight />
                    </IconButton>
                </Stack>
            </Grid>
            <Grid item>
                <ButtonGroup variant="outlined" aria-label="outlined button group">
                    {viewOptions.map(viewOption => {
                        const Icon = viewOption.icon;
                        return (
                            <Tooltip title={<FormattedMessage id={viewOption.label} />} key={viewOption.value}>
                                <Button
                                    disableElevation
                                    variant={viewOption.value === view ? "contained" : "outlined"}
                                    onClick={() => handleChangeView(viewOption.value)}
                                >
                                    <Icon stroke="2" size="1.3rem" />
                                </Button>
                            </Tooltip>
                        );
                    })}
                </ButtonGroup>
            </Grid>
        </Grid>
    );
};

Toolbar.propTypes = {
    locale: PropTypes.object,
    calendarActions: PropTypes.func
};

export default Toolbar;
